const {
  REACT_APP_API_URL, REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY, REACT_APP_SUPPORT_EMAIL, REACT_APP_FACEBOOK_URL,
  REACT_APP_GOOGLE_ANALYTICS_KEY, REACT_APP_PAYPAL_URL, REACT_APP_BUYMEACOFFEE_URL, REACT_APP_CRYPTO_WALLET
} = process.env;

export const API_URL = REACT_APP_API_URL || '';
export const SUPPORT_EMAIL = REACT_APP_SUPPORT_EMAIL || '';
export const FACEBOOK_URL = REACT_APP_FACEBOOK_URL || '';
export const PAYPAL_URL = REACT_APP_PAYPAL_URL || '';
export const BUYMEACOFFEE_URL = REACT_APP_BUYMEACOFFEE_URL || '';
export const CRYPTO_WALLET = REACT_APP_CRYPTO_WALLET || '';

// Site author credit, shown in the global footer.
export const DEVELOPER_NAME = 'Nikol M.';
export const DEVELOPER_URL = 'https://nikolmarg.com';

export const GOOGLE_RECAPTCHA_SITE_KEY = REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || '';
export const GOOGLE_ANALYTICS_KEY = REACT_APP_GOOGLE_ANALYTICS_KEY || '';

export const FILE_UPLOAD_MAX_SIZE = 12 * 1024 * 1024; // in bytes
export const DEFAULT_PAGINATION_SIZE = 10;

// Navigation routes
export const NAV_ROOT = '/';
export const NAV_LOGIN = '/login';
export const NAV_HOME = '/';
export const NAV_NDES = '/ndes';
export const NAV_NDES_CREATE = `${NAV_NDES}/new`;
export const NAV_NDES_EDIT = `${NAV_NDES}/edit/:ndeUuid`;
export const NAV_NDES_VIEW = `${NAV_NDES}/:ndeId`;
export const NAV_PRIVACY_POLICY = '/privacy';
export const NAV_LEGAL_NOTICE = '/legal-notice';
export const NAV_FAQ = '/faq';
export const NAV_ABOUT = '/about';
export const NAV_JOIN_US = '/join-us';
export const NAV_DONATE = '/donate';
export const NAV_STATISTICS = '/statistics';
export const NAV_NOT_FOUND = '/not-found';

// Blog routes
export const NAV_BLOG = '/blog';
export const NAV_BLOG_POST = '/blog/:slug';
export const NAV_BLOG_AUTHOR = '/blog/author/:slug';
export const NAV_BLOG_LOGIN = '/blog/login';
export const NAV_BLOG_EDITOR_NEW = '/blog/editor/new';
export const NAV_BLOG_EDITOR_EDIT = '/blog/editor/:id';

export const NAV_RELATIVE_NDES_BASIC_DETAILS = '/basic-details';
export const NAV_RELATIVE_NDES_DEATH_DETAILS = '/death-details';
export const NAV_RELATIVE_NDES_ADVANCED_DETAILS = '/advanced-details';
export const NAV_RELATIVE_NDES_PERSONAL_DETAILS = '/personal-details';

export const ERROR_CODES = {
  '001': 'TODO'
};

// Local storage data
export const STORAGE_KEYS = {
  ACCEPTED_COOKIES: 'nde/hasAcceptedCookies',
  NDE_TO_CREATE: 'nde/unsavedNde',
  OWN_NDE_UUIDS: 'nde/ownNdes',
  BLOG_AUTH_TOKEN: 'blog/authToken',
  BLOG_AUTH_AUTHOR: 'blog/authAuthor'
};

// NDE enums (mirroring backend entity enums)
export const NDE_TYPES = {
  PEACEFUL: 'peaceful',
  DISTRESSING: 'distressing',
  NEUTRAL: 'neutral',
  MIXED: 'mixed'
};

export const BINARY_ANSWERS = {
  YES: 'yes',
  NO: 'no'
};

export const TERNARY_ANSWERS = {
  YES: 'yes',
  NO: 'no',
  OTHER: 'other'
};

export const ENVIRONMENTS = {
  EARTH: 'earth',
  PLACE_OF_LOVE: 'placeOfLove',
  PLACE_OF_SUFFERING: 'placeOfSuffering',
  VOID: 'void',
  OTHER: 'other'
};

export const BODY_FUNCTIONS = {
  BREATHING_STOPPED: 'breathingStopped',
  HEART_STOPPED: 'heartStopped',
  BRAIN_STOPPED: 'brainStopped',
  COMA: 'coma'
};

export const TIME_PERCEPTIONS = {
  FASTER: 'faster',
  SLOWER: 'slower',
  UNCHANGED: 'unchanged',
  NO_TIME: 'noTime',
  OTHER: 'other'
};

export const REALITY_PERCEPTIONS = {
  DREAMLIKE: 'dreamlike',
  LIFELIKE: 'lifelike',
  MORE_REAL_THAN_LIFE: 'moreRealThanLife',
  OTHER: 'other'
};

export const ENTITY_TYPES = {
  LOVED_ONES_DEAD: 'lovedOnesDead',
  LOVED_ONES_ALIVE: 'lovedOnesAlive',
  SPIRITS_BENEVOLENT: 'spiritsBenevolent',
  SPIRITS_MALEVOLENT: 'spiritsMalevolent',
  PETS: 'pets',
  ANIMALS: 'animals'
};

export const FELT_JUDGED = {
  YES_SELF: 'yesSelf',
  YES_OTHER: 'yesOther',
  NO: 'no'
};

export const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
  NON_BINARY: 'nonBinary',
  OTHER: 'other'
};

export const SEXUALITIES = {
  HETEROSEXUAL: 'heterosexual',
  HOMOSEXUAL: 'homosexual',
  BISEXUAL: 'bisexual',
  ASEXUAL: 'asexual',
  OTHER: 'other'
};

// Config for the filter in the NDEs table
export const FILTER_CONFIG = [
  {
    name: 'text',
    label: 'Text',
    fieldType: 'string',
    command: 'like'
  },
  {
    name: 'type',
    label: 'Type',
    fieldType: 'array',
    command: 'like'
  },
  {
    name: 'environment',
    label: 'Environment',
    fieldType: 'array',
    command: 'like'
  },
  {
    name: 'deathDuration',
    label: 'Death duration',
    fieldType: 'string',
    command: 'equal'
  },
  {
    name: 'timePerception',
    label: 'Time perception',
    fieldType: 'array',
    command: 'like'
  },
  {
    name: 'hadObe',
    label: 'Had OBE',
    fieldType: 'boolean',
    command: 'like'
  }
];

export const PREVIEW_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view'
};
